import { z } from 'zod'

import { PromotionPlacementZod } from './promotions-zod'

export const UpdatePromotionPlanZod = z.object({
  regionId: z.string().min(1),
  initiativeId: z.string().min(1),
  placement: PromotionPlacementZod,
  inPlan: z.boolean(),
  overrideLock: z.boolean().optional().default(false),
})
export type UpdatePromotionPlan = z.input<typeof UpdatePromotionPlanZod>

export const PromotionPlanExportZod = z.object({
  initiativeId: z.string().min(1),
})
export type PromotionPlanExport = z.infer<typeof PromotionPlanExportZod>

export const PROMOTION_PLACEMENT_LOCKED_REASON = 'placement-locked'
